import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AnimatePresence, motion } from "framer-motion";

export function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setShow(false);
  };

  const decline = () => {
    localStorage.setItem("cookie_consent", "declined");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 pointer-events-none"
        >
          <div className="bg-[#151515] text-[#eee9e3] max-w-4xl mx-auto rounded-[20px] p-6 shadow-2xl border border-[#333] flex flex-col md:flex-row items-center justify-between gap-6 pointer-events-auto">
            <div className="text-sm md:text-base opacity-90 leading-relaxed font-mono">
              We use cookies to improve your experience, analyze site traffic,
              and support our marketing efforts. By clicking "Accept", you agree
              to our use of cookies as described in our{" "}
              <a
                href="/cookie-policy"
                className="underline hover:text-primary transition-colors"
              >
                Cookie Policy
              </a>{" "}
              and{" "}
              <a
                href="/privacy-policy"
                className="underline hover:text-primary transition-colors"
              >
                Privacy Policy
              </a>
              .
            </div>
            <div className="flex items-center gap-3 shrink-0 w-full md:w-auto">
              <Button
                onClick={decline}
                variant="outline"
                className="flex-1 md:flex-none border-[#444] text-black hover:bg-[#333] hover:text-white transition-colors"
              >
                Decline
              </Button>
              <Button
                onClick={accept}
                className="flex-1 md:flex-none bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
              >
                Accept All
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
